import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import AppLayout from '../AppLayout';
import AppLayoutHeader from '../AppLayout/AppLayoutHeader';
import FlowHeaderMenu from './FlowHeaderMenu';

import styles from './FlowAppLayoutWrapper.module.less';

function FlowAppLayoutWrapper() {
    const location = useLocation();
    const isWechatPage = /\/wechat(?:\/|$)/.test(location.pathname);

    return (
        <AppLayout
            header={
                <AppLayoutHeader
                    titleClassName={styles.title}
                    actionClassName={styles.avatarAction}
                    avatarProps={{ avatarClassName: styles.avatar }}
                >
                    <FlowHeaderMenu />
                </AppLayoutHeader>
            }
            className={styles.body}
            mainClassName={styles.mainContent}
            headerClassName={styles.header}
            contentContainerClassName={classNames(styles.content, {
                [styles.wechatContent]: isWechatPage,
            })}
        >
            <Outlet />
        </AppLayout>
    );
}

export default FlowAppLayoutWrapper;
